
<script>
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  export let edit;
  export let field;
  export let value;
  let loading = false;

  function submitHandler(e) {
    e.currentTarget.blur();
    loading = true;
    let data = new FormData();
    data.append("field", field);
    data.append("value", value);
    dispatch("message", {
        type: "save",
        data: data
    });
    value = "";
    loading = false;
  }

  function closeHandler(e) {
    e.currentTarget.blur();
    dispatch("message", {
        type: "edit",
    });
  }
</script>

<div class="modal modal-sm {edit ? "active" : ""}">
    <div class="modal-overlay" on:click={closeHandler} aria-label="Close"></div>
    <div class="modal-container">
        <div class="modal-header">
            <ul class="tab tab-bar">
              <li class="tab-item active">
                <button class="btn btn-link" style="cursor:default;">
                  Edit {field}
                </button>
              </li>
              <li class="tab-item tab-action">
                <button class="btn btn-clear float-right" on:click={closeHandler} aria-label="Close"></button>
              </li>
            </ul>
        </div>
        <div class="modal-body">
            <form on:submit|preventDefault={submitHandler}>
                <input type="text" class="form-input input-lg" bind:value={value}>
                <input type="submit" style="position: absolute; left: -9999px"/>
                <div class="btn-group btn-group-block">
                {#if loading}
                  <button class="btn btn-lg btn-primary loading">Submit</button>
                {:else}
                  <button class="btn btn-lg btn-primary" on:click|preventDefault={submitHandler}>Submit</button>
                {/if}
                </div>
            </form>
        </div>
    </div>
</div>

<style>
  .modal.modal-sm .modal-container {
    padding: 0;
  }
  .tab {
    margin-top: 0;
    padding: 0 0.8rem;
    border-color:  #00ab5f;
    border-width: 0.1rem;
  }
  .tab-item {
    text-align: center;
  }
  .tab-item .btn-link {
    width: 100%;
  }
  .tab.tab-bar .tab-item.active .btn-link {
    border-bottom-color: transparent;
  }
  .modal-header {
    padding: 0;
  }
  form input:not(:first-child) {
    margin-top: 0.4rem;
  }
  .btn-group {
    padding-top: 0.8rem;
  }
</style>